const blobUrlCache = new Map();

export const getImageFromCache = (key) => blobUrlCache.get(key) || null;

export const storeImageInCache = (key, blobUrl) => {
  blobUrlCache.set(key, blobUrl);
};

export const revokeCachedUrl = (key) => {
  const url = blobUrlCache.get(key);
  if (url) URL.revokeObjectURL(url);
  blobUrlCache.delete(key);
};

// Alias for semantic clarity when priming CDN URLs (not object URLs)
export const primeImageCache = (key, url) => {
  if (!key || !url) return;
  blobUrlCache.set(key, url);
};